import { Company } from 'generated/apolloComponents'
import CompanyHeaderInfo from '@/components/molecules/CompanyHeaderInfo'
import styles from '../Company.module.scss'

type Props = {
  company: Company
}

const BasicLayout = ({ company }: Props) => {
  if (!company.currentLayout) {
    return null
  }

  return (
    <header
      className={`${styles['company__cover--basic']} relative bg-gray-bg rounded-xl container overflow-hidden`}
    >
      <CompanyHeaderInfo
        company={company}
        layout={company.currentLayout}
        className='rounded-xl'
        headerTheme='dark'
      />
    </header>
  )
}

export default BasicLayout
